/* eslint-disable */
import * as registry from '../registry.js'
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ total: NonNullable<unknown> }} Meta_Shown_Legends_AllInputs */



/**
* | totalPlural | output |
* | --- | --- |
* | "one" | "{totalFormatted} legend" |
* | * | "{totalFormatted} legends" |
*
* @param {Meta_Shown_Legends_AllInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const meta_shown_legends_all = /** @type {((inputs: Meta_Shown_Legends_AllInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meta_Shown_Legends_AllInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") {
		const totalPlural = registry.plural("de", i?.total, {}, true);
		const totalFormatted = registry.number("de", i?.total, {}, true);
		if (totalPlural === "one") return /** @type {LocalizedString} */ (`${totalFormatted} Legende`);
		return /** @type {LocalizedString} */ (`${totalFormatted} Legenden`)
	}
	if (locale === "fr") {
		const totalPlural = registry.plural("fr", i?.total, {}, true);
		const totalFormatted = registry.number("fr", i?.total, {}, true);
		if (totalPlural === "one") return /** @type {LocalizedString} */ (`${totalFormatted} légende`);
		return /** @type {LocalizedString} */ (`${totalFormatted} légendes`)
	}
	if (locale === "zh-Hans") {
		const totalPlural = registry.plural("zh-Hans", i?.total, {}, true);
		const totalFormatted = registry.number("zh-Hans", i?.total, {}, true);
		if (totalPlural === "one") return /** @type {LocalizedString} */ (`${totalFormatted} 张传奇`);
		return /** @type {LocalizedString} */ (`${totalFormatted} 张传奇`)
	}
	if (locale === "zh-Hant") {
		const totalPlural = registry.plural("zh-Hant", i?.total, {}, true);
		const totalFormatted = registry.number("zh-Hant", i?.total, {}, true);
		if (totalPlural === "one") return /** @type {LocalizedString} */ (`${totalFormatted} 張傳奇`);
		return /** @type {LocalizedString} */ (`${totalFormatted} 張傳奇`)
	}
	if (locale === "ko") {
		const totalPlural = registry.plural("ko", i?.total, {}, true);
		const totalFormatted = registry.number("ko", i?.total, {}, true);
		if (totalPlural === "one") return /** @type {LocalizedString} */ (`전설 ${totalFormatted}개`);
		return /** @type {LocalizedString} */ (`전설 ${totalFormatted}개`)
	}
	{
		const totalPlural = registry.plural("en", i?.total, {}, true);
		const totalFormatted = registry.number("en", i?.total, {}, true);
		if (totalPlural === "one") return /** @type {LocalizedString} */ (`${totalFormatted} legend`);
		return /** @type {LocalizedString} */ (`${totalFormatted} legends`)
	}
});